module.exports = __webpack_public_path__ + "img/portrait-001.5c86cfe8.jpg";